<sss-navbar-side-menu
  id="scope-navbar-side-menu"
  collapsible="true"
  expanded="true"
  (navbarSideMenuExpandedStateChanged)="sideMenuStateChanged($event)"
>
  @if (viewOverviewLink) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'Overview' }}" culture="en-GB">
      <i class="icon-override icon-fms-override cui-scania-fms-overview"></i>
      <a id="nav-overview" class="sss-navbar-menu-nav-link" routerLink="/overview">{{ 'Overview' | translate }}</a>
    </sss-navbar-menu-item>
  }
  @if (ViewChargingDashboard$ | async) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'Dashboard' }}" culture="en-GB">
      <i class="icon-override">
        <tds-icon name="truck" size="24px" />
      </i>
      <a id="nav-my-electric-vehicles" class="sss-navbar-menu-nav-link" routerLink="/my-electric-vehicles">
        {{ 'CHS_YourElectricVehicles' | translate }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewPublicCharging()) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'Scania Charging Access' }}">
      <i class="icon-override">
        <tds-icon name="card" size="24px" />
      </i>
      <a id="nav-charging-management" class="sss-navbar-menu-nav-link" routerLink="/charging-management">
        {{ 'Scania Charging Access' }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewMap()) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'CHS_MapofChSt' | translate }}">
      <i class="icon-override">
        <tds-icon name="pin" size="24px" />
      </i>
      <a id="nav-map" class="sss-navbar-menu-nav-link" routerLink="/map">
        {{ 'CHS_MapofChSt' | translate }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewDepartureScheduling$ | async) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'Departure scheduling' }}">
      <i class="icon-override">
        <tds-icon name="departure_scheduling" size="24px" />
      </i>
      <a id="nav-depature-scheduling" class="sss-navbar-menu-nav-link" routerLink="/departure-scheduling">
        {{ 'CHS_DepartureScheduling' | translate }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewChargingDashboardFunc$ | async) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'CHS_ChargingSessions' | translate }}">
      <i class="icon-override">
        <tds-icon name="history" size="24px" />
      </i>
      <a id="nav-charging-sessions" class="sss-navbar-menu-nav-link" routerLink="/charging-sessions">
        {{ 'CHS_ChargingSessions' | translate }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewChargingSettings$ | async) {
    <sss-navbar-menu-item routerLinkActive="active" label="{{ 'CHS_Settings' }}" culture="en-GB">
      <i class="icon-override">
        <tds-icon name="message" size="24px" />
      </i>
      <a id="nav-charging-settings" class="sss-navbar-menu-nav-link" routerLink="/settings">
        {{ 'CHS_ChargingNotifications' | translate }}
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewVasBlack()) {
    <sss-navbar-menu-item routerLinkActive="active" label="Certificate settings">
      <i class="icon-override">
        <tds-icon name="settings" size="24px" />
      </i>
      <a id="nav-certificate-settings" class="sss-navbar-menu-nav-link" routerLink="/certificate-settings">
        Certificate settings
      </a>
    </sss-navbar-menu-item>
  }
  @if (viewAdmin()) {
    <sss-navbar-menu-item routerLinkActive="active" label="Admin">
      <i class="icon-override">
        <tds-icon name="key" size="24px" />
      </i>
      <a id="nav-admin" class="sss-navbar-menu-nav-link" routerLink="/admin">Developer Admin</a>
    </sss-navbar-menu-item>
  }
</sss-navbar-side-menu>

<ng-content />
